export const AGENT_MODEL_DEFAULT = 'perform';

export const AGENT_MODELS = [
  { value: 'perform', label: 'Perform' },
  { value: 'library', label: 'Library' },
];

const AGENT_MODEL_VALUES = AGENT_MODELS.map((model) => model.value);

export const normalizeAgentModel = (value) => (AGENT_MODEL_VALUES.includes(value) ? value : AGENT_MODEL_DEFAULT);

const firstValue = (source = {}, paths = []) => {
  for (const path of paths) {
    const value = path.split('.').reduce((current, key) => (current == null ? undefined : current[key]), source);
    if (value !== undefined && value !== null) return value;
  }
  return undefined;
};

export const getAgentModelFromConversation = (conversation = {}) =>
  normalizeAgentModel(firstValue(conversation, ['agent_model', 'agentModel']));

export const getAgentModelFromUser = (user = {}) =>
  normalizeAgentModel(firstValue(user, ['meta.agent_model', 'meta.agentModel']));
